export enum Endpoint {
  users = "/v2/users",
  organizations = "/v2/organizations",
  goals = "/v2/goals",
  tasks = "/v2/tasks",
  auth = "/v2/authentication",
  userReports = "/v2/user-reports"
}